import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-287d4260"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-center w-full px-3" }
const _hoisted_2 = { class: "flex gap-4 flex-wrap items-center mb-2" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold pl-1" }, " From: ", -1))
const _hoisted_5 = { class: "pl-1" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold pl-1" }, " To: ", -1))
const _hoisted_8 = { class: "pl-1" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = {
  key: 0,
  class: "inline-flex flex-wrap gap-3"
}
const _hoisted_11 = {
  class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
  "data-toggle": "modal",
  "data-target": "#moveToFolderSingleModal",
  "data-placement": "bottom",
  title: "Move to Folder"
}
const _hoisted_12 = {
  class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
  "data-toggle": "tooltip",
  "data-placement": "bottom",
  title: "Print"
}
const _hoisted_13 = {
  class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
  "data-toggle": "dropdown",
  "data-placement": "leftbottom",
  title: "Options"
}
const _hoisted_14 = {
  class: "dropdown-menu p-0",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_15 = {
  class: "modal fade",
  id: "moveToFolderSingleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "moveToFolderSingleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_16 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "moveToFolderSingleModalLabel"
  }, " Move to folder "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Move to folder...", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-secondary px-5",
  "data-dismiss": "modal"
}, " Cancel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            class: "from-style text-sm pb-1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchEmails(_ctx.from))),
            title: "Search Emails"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createVNode(_component_font_awesome_icon, {
                  class: "email-search-icon text-secondary",
                  icon: ['fas', 'search']
                })
              ]),
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.from), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "from-style text-sm pb-1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchEmails(_ctx.to))),
            title: "Search Emails"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createVNode(_component_font_awesome_icon, {
                  class: "email-search-icon text-secondary",
                  icon: ['fas', 'search']
                })
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.to), 1)
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_font_awesome_icon, {
              class: "mr-1",
              icon: ['far', 'clock']
            }),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$filters.dateTime(_ctx.dateCreated)), 1)
          ])
        ])
      ]),
      (_ctx.isReply === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollToReply && _ctx.scrollToReply(...args))),
              class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              title: "Reply"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-secondary",
                icon: ['fas', 'reply']
              })
            ]),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.scrollToForward && _ctx.scrollToForward(...args))),
              class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              title: "Forward"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-secondary",
                icon: ['fas', 'share']
              })
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-secondary",
                icon: ['fas', 'inbox']
              })
            ]),
            _createElementVNode("div", {
              class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              title: "Move to Junk",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.moveToJunk(false)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-secondary",
                icon: ['fas', 'exclamation-circle']
              })
            ]),
            (!_ctx.isProtected)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "email-button bg-gray d-flex align-items-center justify-content-center cursor-pointer",
                  "data-toggle": "tooltip",
                  "data-placement": "bottom",
                  title: "Delete",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteEmail()))
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "text-secondary",
                    icon: ['fas', 'trash-alt']
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: { name: 'print-email', params: { emailId: _ctx.emailId }},
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, {
                    class: "text-secondary",
                    icon: ['fas', 'print']
                  })
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-secondary",
                icon: ['fas', 'ellipsis-h']
              }),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn btn-text no-focus",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.moveToJunk(true)))
                }, " Junk and Block ")
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.targetFolderId) = $event)),
                class: "custom-select no-focus w-100"
              }, [
                _hoisted_20,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders.folders, (fld) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: fld.id,
                    key: fld.id
                  }, _toDisplayString(fld.name), 9, _hoisted_21))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.targetFolderId]
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                "data-dismiss": "modal",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.moveToFolder()), ["prevent"]))
              }, " Move ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_confirm_dialog, { ref: "confirmDialog" }, null, 512)
  ], 64))
}